import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { push } from 'react-router-redux';
import DocumentMeta from 'react-document-meta';
import FestivalSponsorSidebar from '../components/festival/sponsorship/FestivalSponsorSidebar';
import {
  loadFestivalSponsorshipCategories
} from '../actions';


class FestivalSponsorship extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    sidebarLinkActive: 'default',
    isTapped: false
  }

  handleTap = (e) => {
    e.preventDefault()
    this.setState({isTapped: !this.state.isTapped})
  }

  parentSetActiveAnchorState = (slug) => {
    this.props.push('/girls-festival/sponsorship#' + slug)
    this.setState({sidebarLinkActive: slug, isTapped: !this.state.isTapped})
  }

  componentWillMount() {
    this.props.loadFestivalSponsorshipCategories({has_description: true});
  }

  componentDidMount() {
    if (typeof(window) !== "undefined") {
      window.scrollTo(0,0)
    }
  }

  render() {

    if (!this.props.festivalSponsorshipCategories.isLoaded) {
      return <span />;
    }

    let sponsorshipCategories = this.props.festivalSponsorshipCategories;
    let sponsorshipList;
    let sponsorshipCategorySponsorsList;
    let sponsorList;
    let categoryHeader;

    let browser = this.props.browser;
    let caretIcon = '';
    let tapStatus = '';

    let benefitsCopy = '';
    let sponsorLevel = '';


    if (this.state.isTapped) {
      tapStatus = 'is-tapped'
      caretIcon = <i className="fa fa-chevron-up"></i>
    } else {
      tapStatus = '';
      caretIcon = <i className="fa fa-chevron-down"></i>
    }

    function createMarkup(content) {
      return { __html: content};
    }

    sponsorshipCategorySponsorsList = sponsorshipCategories.map((category, index) => {

      benefitsCopy = <div className="festivalOurSponsors-categoryWrapperInner" dangerouslySetInnerHTML={createMarkup(category.benefits)}></div>;

      if (category.sponsor_category_name == "Platinum") {
        sponsorLevel = category.sponsor_category_name + ' Sponsor ' + category.donation_amount_range;
      } else if (category.sponsor_category_name.indexOf(' bus') > 0) {
        sponsorLevel = category.sponsor_category_name +  category.donation_amount_range;
      } else {
        sponsorLevel = category.sponsor_category_name + ' Sponsor ' + category.donation_amount_range;
      }


      return <div className="section-block">
                <a name={category.slug}></a>
                <h2 className="section-head">{sponsorLevel}</h2>
                {benefitsCopy}
            </div>
    });

    return(
      <div>

        <div className="festivalHome-bannerWrapper">
          <a href="/girls-festival/tickets"><img className="desktop" src="/images/festival/home/2019/gf_banner_desktop_01.jpg" /></a>

          <a href="/girls-festival/tickets"><img className="mobile" src="/images/festival/home/2019/gf_banner_mobile_01.jpg" /></a>
        </div>

        <div id="mobile-subnav-wrapper">
          <div id="mobile-subnav" className="subnavigation">

            <div onClick={this.handleTap} className="sub-menu-icon">
              <a href="#">Sponsorship {caretIcon}</a>
            </div>
            <FestivalSponsorSidebar
              festivalSponsorshipCategories={this.props.festivalSponsorshipCategories}
              parentSetActiveAnchorState={this.parentSetActiveAnchorState}
              tapStatus={tapStatus}
              handleTap={this.handleTap}
            />
          </div>
        </div>



        <div className="content-wrapper">

          <div className="festivalProgram2ColWrapper">
            <div className="festivalSidebar-wrapper">

              <FestivalSponsorSidebar
                festivalSponsorshipCategories={this.props.festivalSponsorshipCategories}
                parentSetActiveAnchorState={this.parentSetActiveAnchorState}
              />

            </div>

            <div className="festivalMainBody-wrapper">
              {/* BEGIN */}
              <h1 className="page-heading">Sponsorship</h1>
              <div className="headerTagWrapper">
                <p>Please join our prestigious sponsor group of Bay Area companies and organizations that support girls both locally and around the world.</p>

                <p>Sponsorship packages range from $75K for our headline sponsorship to $1K from our friends and family. We will customize your participation and contribution to your goals.</p>
              </div>

              <div className="sponsorshipCategorySponsorsListWrapper">{sponsorshipCategorySponsorsList}</div>


              <div className="footer">
                  <p>*The Festival is hosted by the WorldWideWomen Foundation, a 501(c)(3) organization.</p>
                  <p>For more information please contact <a href="mailto:imccomish@worldwidewomen.co">Isabel McComish</a>.</p>
              </div>

              {/* END */}
            </div>

          </div>





        </div>{/* End:festivalHome-bannerWrapper */}
      </div>
    )
  }
};

function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps,
  {
    push,
    loadFestivalSponsorshipCategories
  }
)(FestivalSponsorship);



// WEBPACK FOOTER //
// ./src/containers/FestivalSponsorship.jsx